"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGO50PauseScene = void 0;
const NinePatch_1 = require("phaser3-rex-plugins/plugins/gameobjects/rendertexture/ninepatch/NinePatch");
const Game_1 = require("./Game");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHContainer_1 = require("./KH/KHContainer");
const IGO50GameListScene_1 = require("./IGO50GameListScene");
const KHInputKeyResettable_1 = require("./KH/Input/Key/KHInputKeyResettable");
const KHListMenuV3_1 = require("./KH/Menu/V3/KHListMenuV3");
const KHListControllerV3_1 = require("./KH/Menu/V3/KHListControllerV3");
const KHMenuSpecV3_1 = require("./KH/Menu/V3/KHMenuSpecV3");
const KHMenuEntryV3_1 = require("./KH/Menu/V3/KHMenuEntryV3");
const KHMenuNavigatorV3_1 = require("./KH/Menu/V3/KHMenuNavigatorV3");
const Z20AudioScene_1 = require("./Z20AudioScene");
const KHRandom_1 = require("./KH/KHRandom");
const IGO50Scenes_1 = require("./IGO50Scenes");
const IGO50Terminal_1 = require("./IGO50Terminal");
var MenuEntries;
(function (MenuEntries) {
    MenuEntries[MenuEntries["Pause"] = 0] = "Pause";
    MenuEntries[MenuEntries["Terminal"] = 1] = "Terminal";
})(MenuEntries || (MenuEntries = {}));
class IGO50PauseScene extends Phaser.Scene {
    constructor() {
        super(IGO50Scenes_1.default.Pause);
    }
    init(data) {
        this.pausedSceneKey = data.pausedSceneKey;
    }
    create() {
        // this.audio_scene.play('bg_audio', true, true, 0.5)
        this.controller = Game_1.gameManager.getController();
        this.controller.register(KHInputScene_1.KHInputScene.SharedInput);
        const startKey = this.controller.getInput(Game_1.Controls.Start);
        startKey.registerCallbackForObject('justDown', this, () => {
            this.resumeGame();
        });
        this.events.on(Phaser.Scenes.Events.SHUTDOWN, () => {
            startKey.unregisterCallbacksForObject('justDown', this);
        });
        this.add.tileSprite(0, 0, Game_1.game.width, Game_1.game.height, 'outer_bg').setOrigin(0);
        this.menuObjects = [];
        this.goToMenu(MenuEntries.Pause);
        // this.createTerminalMenu();
    }
    createBorder(x, y, width, height) {
        return new NinePatch_1.default(this, {
            x: x, y: y, width: width + 16, height: height + 16,
            key: 'outer_border',
            columns: [7, undefined, 7],
            rows: [7, undefined, 7],
        }).setOrigin(0, 0);
    }
    goToMenu(menu) {
        for (const obj of this.menuObjects) {
            obj.destroy();
        }
        switch (menu) {
            case MenuEntries.Pause:
                this.createPauseMenu();
                break;
            case MenuEntries.Terminal:
                this.createTerminalMenu();
                break;
            default:
                this.resumeGame();
                break;
        }
    }
    createTerminalMenu() {
        const width = 160;
        const height = 16 + 16 * 4;
        const yOff = 32;
        this.menuObjects = [];
        const add = (obj) => {
            this.menuObjects.push(obj);
            return obj;
        };
        const container = add(new KHContainer_1.KHContainer(this, (Game_1.game.width - width) / 2 - 64, (Game_1.game.height - height) / 2 + yOff, width, height));
        const bg = this.createBorder(-8, -8, width, height);
        this.add.existing(bg);
        container.add(bg);
        const titleText = add(this.add.bitmapText(Game_1.game.width / 2, 16, 'legacys', 'TERMINAL').setOrigin(0.5, 0.5).setDropShadow(1, 0, 0x0, 1).setDepth(1));
        this.add.existing(add(this.createBorder(titleText.x, titleText.y, titleText.width, titleText.height).setOrigin(0.5, 0.5)));
        let terminalString = '';
        const entryText = add(this.add.bitmapText(Game_1.game.width / 2 - 64, 64, 'legacys', '*___-____').setOrigin(0.5, 0.5).setDropShadow(1, 0, 0x0, 1).setDepth(1));
        this.add.existing(add(this.createBorder(entryText.x, entryText.y, entryText.width + 64, entryText.height).setOrigin(0.5, 0.5)));
        let memorySampler = 'ABCDEFGHIJKLMNOPQRSRTUVWXYZabcdefghijklmnopqrstuvwxyz!?"#$%&()+,.-/\\:;<=>[]{}^';
        const memWidth = 12;
        const memHeight = 16;
        let emptyChar = '.';
        const memoryText = add(this.add.bitmapText(Game_1.game.width / 2 + 96, 16 * 7.5, 'igo50', '').setOrigin(0.5, 0.5).setDropShadow(1, 0, 0x0, 1).setDepth(1));
        function updateMemoryText(code) {
            const random = new KHRandom_1.KHRandomGeneral();
            const terminalRow = random.nextInt(4, 12);
            let str = '';
            for (let i = 0; i < memHeight; i++) {
                if (i === terminalRow) {
                    if (code) {
                        let offset = random.nextInt(0, memWidth - code.length + 1);
                        str += emptyChar.repeat(offset) + code + emptyChar.repeat(memWidth - offset - code.length);
                    }
                    else {
                        str += emptyChar.repeat(memWidth);
                    }
                }
                else {
                    // Empty row
                    if (random.withChance(0.2)) {
                        str += emptyChar.repeat(memWidth);
                    }
                    else {
                        const rowStrength = random.nextFloat(0.2, 0.9);
                        for (let i = 0; i < memWidth; i++) {
                            str += random.withChance(rowStrength) ? memorySampler[random.nextInt(0, memorySampler.length)] : emptyChar;
                        }
                    }
                }
                str += '\n';
            }
            memoryText.text = str;
        }
        function updateMemoryTextStatic(text) {
            const splitText = text.split('\n');
            let str = '';
            for (let i = 0; i < memHeight; i++) {
                if (i < splitText.length)
                    str += splitText[i].trim().padEnd(memWidth, emptyChar);
                else
                    str += emptyChar.repeat(memWidth);
                str += '\n';
            }
            memoryText.text = str;
        }
        updateMemoryText(IGO50Terminal_1.default.CurrentCode);
        add(this.add.existing(this.createBorder(memoryText.x, memoryText.y, memoryText.width, memoryText.height + 16).setOrigin(0.5, 0.5)));
        function updateTerminalText(key) {
            if (key === '<') {
                if (terminalString.length > 0)
                    terminalString = terminalString.substring(0, terminalString.length - 1);
            }
            else if (key === '-') {
                terminalString = '';
            }
            else {
                terminalString = (terminalString + key).substring(0, 8);
            }
            let inProgressString = terminalString;
            if (terminalString.length >= 8) {
                inProgressString = terminalString.substring(0, 4) + '-' + terminalString.substring(4, 8);
                checkCode(terminalString);
            }
            else if (terminalString.length >= 4) {
                inProgressString = terminalString.substring(0, 4) + '-' + terminalString.substring(4) + '*';
                inProgressString = inProgressString.padEnd(9, '_');
            }
            else {
                inProgressString = terminalString.substring(0) + '*';
                inProgressString = inProgressString.padEnd(4, '_');
                inProgressString += '-____';
            }
            entryText.text = inProgressString;
        }
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789?!<-';
        const lineWidth = 8;
        const options = [];
        for (let i = 0; i < letters.length; i++) {
            const char = letters.charAt(i);
            let x = i % lineWidth;
            let y = Math.floor(i / lineWidth);
            options.push(new KHMenuEntryV3_1.KHMenuEntryV3({
                text: char,
                selectable: true,
                confirmCallback: () => {
                    updateTerminalText(char);
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_bad');
                },
                extras: {
                    x, y
                }
            }));
        }
        const menuSpec = new KHMenuSpecV3_1.KHMenuSpecV3({ title: 'TERMINAL',
            menuNavigator: new KHMenuNavigatorV3_1.KHMenuNavigatorV32D(true),
            menuEntries: options,
            cancelCallback: () => {
                Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_bad');
                this.goToMenu(MenuEntries.Pause);
            }
        });
        const w = container.c_w - 20;
        const per = w / lineWidth;
        const sx = (container.c_w - per * lineWidth);
        add(new KHListMenuV3_1.KHListMenuV3({
            scene: this,
            registrar: KHInputScene_1.KHInputScene.SharedInput,
            controller: KHListControllerV3_1.KHListControllerV3.default(),
            menuSpec,
            rect: new Phaser.Geom.Rectangle(container.x, container.y, container.c_w, container.c_h),
            optionCreationCallback: (createObject) => {
                const extras = createObject.menuOption.extras;
                const text = this.add.bitmapText(extras.x * per + sx, 8 + extras.y * 16, 'legacys', createObject.menuOption.getText()).setOrigin(0.5, 0.5);
                function setSelected(selected) {
                    text.setTint(selected ? IGO50PauseScene.HIGHLIGHT_COLOR : 0xFFFFFF);
                }
                setSelected(createObject.menuOption.getIsSelected());
                createObject.menuOption.registerCallback("is_selected_updated", (data) => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    setSelected(data.selected);
                });
                const bounds = text.getTextBounds(true).global;
                return { go: text, bounds: new Phaser.Geom.Rectangle(bounds.x, bounds.y, bounds.width, bounds.height) };
            }
        }));
        function isCodeValid(code) {
            const allGames = IGO50GameListScene_1.IGO50Games;
            for (const game of allGames) {
                for (const codes of game.terminal_codes) {
                    if (codes.code === code)
                        return codes.action;
                }
            }
            return undefined;
        }
        const checkCode = (code) => {
            menuSpec.setForbidInput(true);
            const inputBlockTime = 1000;
            const codeAction = isCodeValid(code);
            if (!codeAction) {
                Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_death');
                updateMemoryTextStatic('INVALID\nCODE!');
                this.time.addEvent({
                    delay: inputBlockTime,
                    callback: () => {
                        updateTerminalText('-');
                        menuSpec.setForbidInput(false);
                        updateMemoryText(IGO50Terminal_1.default.CurrentCode);
                    }
                });
                return;
            }
            // Valid code case
            Z20AudioScene_1.Z20AudioScene.Shared.playSfx('win');
            updateMemoryTextStatic('CODE\nACCEPTED!');
            this.closePausedScene();
            this.time.addEvent({
                delay: inputBlockTime,
                callback: () => {
                    updateTerminalText('-');
                    codeAction(this);
                    menuSpec.setForbidInput(false);
                }
            });
        };
    }
    createPauseMenu() {
        const width = 160;
        const height = 96;
        const yOff = 8;
        this.menuObjects = [];
        const add = (obj) => {
            this.menuObjects.push(obj);
            return obj;
        };
        const container = add(new KHContainer_1.KHContainer(this, (Game_1.game.width - width) / 2, (Game_1.game.height - height) / 2 + yOff, width, height));
        const bg = this.createBorder(-8, -8, width, height);
        this.add.existing(bg);
        container.add(bg);
        add(this.add.bitmapText(Game_1.game.width / 2, container.y - 16, 'legacys', 'PAUSE MENU').setOrigin(0.5, 0.5).setDropShadow(1, 0, 0x0, 1));
        const menuSpec = new KHMenuSpecV3_1.KHMenuSpecV3({ title: 'PAUSE MENU',
            menuNavigator: new KHMenuNavigatorV3_1.KHMenuNavigatorV31D(KHMenuNavigatorV3_1.NavigationDirection.Vertical),
            menuEntries: [
                this.addClickableOption('TERMINAL', () => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    this.goToMenu(MenuEntries.Terminal);
                }),
                this.addText(''),
                this.addClickableOption('Resume Game', () => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    this.resumeGame();
                }, true),
                this.addClickableOption('Reset Game', () => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    this.closePauseAndGoTo(IGO50GameListScene_1.ForestWernat.sceneKey);
                }),
                this.addClickableOption('Return to Library', () => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('tick');
                    this.closePauseAndGoTo(IGO50Scenes_1.default.GameList);
                }),
            ],
            cancelCallback: () => {
                Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_bad');
                this.resumeGame();
            }
        });
        let currY = 16;
        add(new KHListMenuV3_1.KHListMenuV3({
            scene: this,
            registrar: KHInputScene_1.KHInputScene.SharedInput,
            controller: KHListControllerV3_1.KHListControllerV3.default(),
            menuSpec,
            rect: new Phaser.Geom.Rectangle(container.x, container.y, container.c_w, container.c_h),
            optionCreationCallback: (createObject) => {
                const text = this.add.bitmapText(container.c_w / 2, currY, 'legacys', createObject.menuOption.getText()).setOrigin(0.5, 0.5);
                function setSelected(selected) {
                    text.setTint(selected ? IGO50PauseScene.HIGHLIGHT_COLOR : 0xFFFFFF);
                }
                setSelected(createObject.menuOption.getIsSelected());
                createObject.menuOption.registerCallback("is_selected_updated", (data) => {
                    Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move');
                    setSelected(data.selected);
                });
                currY += 16;
                const bounds = text.getTextBounds(true).global;
                return { go: text, bounds: new Phaser.Geom.Rectangle(bounds.x, bounds.y, bounds.width, bounds.height) };
            }
        }));
    }
    closePausedScene() {
        if (this.pausedSceneKey) {
            this.scene.stop(this.pausedSceneKey);
        }
    }
    closePauseAndGoTo(key) {
        this.closePausedScene();
        this.scene.start(key);
    }
    resumeGame() {
        if (this.pausedSceneKey) {
            const interactKey = this.controller.getInput(Game_1.Controls.Confirm);
            if (interactKey instanceof KHInputKeyResettable_1.KHInputKeyResettable) {
                interactKey.reset();
            }
            this.scene.resume(this.pausedSceneKey);
            this.scene.stop(this.scene.key);
        }
    }
    update(time, delta) {
        if (this.controller.getInput(Game_1.Controls.Start).isJustDown()) {
            Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move_bad');
            this.resumeGame();
        }
    }
    addText(optionText) {
        return KHMenuEntryV3_1.KHMenuEntryV3.JustText(optionText);
    }
    addClickableOption(optionText, callback, isDefault = false) {
        return new KHMenuEntryV3_1.KHMenuEntryV3({
            text: optionText,
            selectable: true,
            confirmCallback: callback,
            isDefaultSelection: isDefault,
        });
    }
}
exports.IGO50PauseScene = IGO50PauseScene;
IGO50PauseScene.HIGHLIGHT_COLOR = 0xe8ea4a;
